import {observer} from "mobx-react";
import SelectSearchMain from "@dropDesk/presentation/components/inputs/select_search_main";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Body, Container, Footer, PaddingFilters} from "./styled";
import FilterButton from "@dropDesk/presentation/components/filters/filter_button";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import React, {useEffect, useRef, useState} from "react";
import {evaluationValueMap} from "@dropDesk/domain/entities/ticket/evaluation/ticket_evaluation_maps";
import {evaluationEnum} from "@dropDesk/domain/entities/ticket/evaluation/ticket_evaluation_enum";
import {useBetween} from "use-between";
import {
    useModalsReportTicketEvaluations
} from "@dropDesk/presentation/pages/ticket/evaluation/ui/search/modals/handle_change_visible";
import SelectSearchUser from "@dropDesk/presentation/components/inputs/select_search_users";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";

const Filters = observer(
    ({
         contact,
         attendant,
         setFilterContact,
         setFilterAttendant,
         loading,
         onSearch,
         searchEvaluationValue,
         setSearchEvaluationValue
     }: {
        setFilterContact: (contact: UserEntity | null, withList?: boolean) => void,
        setFilterAttendant: (attendant: UserEntity | null, withList?: boolean) => void,
        setSearchEvaluationValue: (value: number | null, withList?: boolean) => void,
        contact: UserEntity | null,
        attendant: UserEntity | null,
        searchEvaluationValue: number | null,
        onSearch: (searchParam?: string) => void,
        loading: boolean,
    }) => {

        const [visible, setVisible] = useState<boolean>(false);
        const [initialized, setInitialized] = useState<boolean>(false);
        const [zIndex, setZIndex] = useState<number>(0);
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const timeoutRef = useRef<number | undefined>(undefined);


        const handleClickChange = (open: boolean, timeout = 200) => {
            if (open) {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                setZIndex(1300);
            } else {
                timeoutRef.current = window.setTimeout(() => {
                    setZIndex(0);
                }, timeout);
            }
            setVisible(open);
        };

        const {
            setVisibleModalSearchAttendant,
            setVisibleModalSearchContacts,
            visibleModalSearchAttendant,
            visibleModalSearchContacts
        } = useBetween(useModalsReportTicketEvaluations);

        useEffect(() => {
            setInitialized(true);
            if ((visibleModalSearchContacts || visibleModalSearchAttendant) && initialized) {
                handleClickChange(false);
            } else if (initialized) {
                handleClickChange(true);
            }

        }, [visibleModalSearchAttendant, visibleModalSearchContacts]);

        return (
            <FilterButton
                hasFilter={(!!contact || !!attendant || searchEvaluationValue !== null && searchEvaluationValue !== undefined)}
                filterCount={[contact, attendant, searchEvaluationValue !== null && searchEvaluationValue !== undefined ? true : null].filter(Boolean).length}
                loading={loading}
                open={visible}
                onOpenChange={handleClickChange}
                zIndex={zIndex}
                content={
                    <>
                        {visible && <Container border={colors.border}>
                            <Body>
                                <PaddingFilters>
                                    <SelectSearchUser
                                        size={40}
                                        useRemoveFilter={!!contact}
                                        label={'Contato'}
                                        placeHolder={"Selecione o contato"}
                                        handleSelectUser={(value, contact) => {
                                            setFilterContact(contact ?? null);
                                        }}
                                        value={contact ? {value: contact.id, label: contact.name} : undefined}
                                        role={UserRole.userClient}
                                        disabled={loading}
                                    />
                                </PaddingFilters>
                                <PaddingFilters>
                                    <SelectSearchUser
                                        size={40}
                                        useRemoveFilter={!!attendant}
                                        label={'Atendente'}
                                        placeHolder={"Selecione o atendente"}
                                        handleSelectUser={(value, attendant) => {
                                            setFilterAttendant(attendant ?? null);
                                        }}
                                        value={attendant ? {value: attendant.id, label: attendant.name} : undefined}
                                        role={UserRole.attendant}
                                        disabled={loading}
                                    />
                                </PaddingFilters>

                                <PaddingFilters>
                                    <SelectSearchMain<evaluationEnum>
                                        size={37}
                                        useRemoveFilter={!!searchEvaluationValue}
                                        label={'Filtrar por avaliação'}
                                        placeHolder={"Selecione o valor"}
                                        options={evaluationValueMap}
                                        removeSort={true}
                                        onClickRemoveFilter={() => {
                                            setSearchEvaluationValue(null);
                                        }}
                                        onChange={(value) => {
                                            setSearchEvaluationValue(value);
                                        }}
                                        value={searchEvaluationValue ? searchEvaluationValue : null}
                                    />
                                </PaddingFilters>

                            </Body>
                            <Footer>
                                <ButtonNew
                                    label={'Limpar filtros'}
                                    onClick={() => {
                                        setFilterAttendant(null, false);
                                        setFilterContact(null, false);
                                        setSearchEvaluationValue(null, false);
                                        onSearch();
                                        setVisible(false);
                                    }}
                                    useIcon={false}
                                    sizeLeftIcon={15}
                                    disabled={loading}
                                    radius={25}
                                />
                            </Footer>
                        </Container>}
                    </>
                }/>

        )
    })
export default Filters;
